import { getOrderCancellationAnalyticsApi } from '@/core/api/generatedApiClient';
import { rethrowHandledApiError } from '@/core/api/rethrowHandledApiError';
import type { OrderCancellationAnalyticsApiGetCancelledOrdersRequest, OrderCancellationAnalyticsResponse } from '@/core/generated/api';

/** Читает административную таблицу отменённых заказов */
export const orderCancellationAnalyticsService = {
    /** Получает страницу и полное количество по серверным фильтрам */
    async getList(
        request: OrderCancellationAnalyticsApiGetCancelledOrdersRequest
    ): Promise<OrderCancellationAnalyticsResponse> {
        try {
            return (await getOrderCancellationAnalyticsApi().getCancelledOrders(request)).data;
        } catch (error: unknown) {
            return rethrowHandledApiError(error);
        }
    },
};
